import React, { useMemo, useState, useEffect, useContext } from "react";
import { useParams } from 'react-router-dom';
import { useNavigate } from 'react-router-dom';

import { Box, IconButton } from "@mui/material";
import VisibilityIcon from '@mui/icons-material/Visibility';
import { useTranslation } from "react-i18next";
import DataTable from "../../common/DataTable";
import { GET_CUSTOMER_PRODUCT_MONTHLY, } from "../../../services/apiRoutes";
import { AuthContext } from "../../../context/AuthContext";
import CustomLoader from "../../common/CustomLoader";
import CustomReport from "../../common/CustomReport";
import { genericPost } from "../../../services/authServices";


const CustomerProductMonthly = () => {
    const navigate = useNavigate();

    const { clientCompanyId } = useParams();
    const { t, i18n } = useTranslation();
    const [data, setData] = useState([]);
    const { token } = useContext(AuthContext);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);
    const [totalGrandQty, setGrandQty] = useState("");
    const [clientCompanyName, setClientCompanyName] = useState("");

    const columns = useMemo(
        () => [
            { accessorKey: 'index', header: 'SN', size: 50, tableStyle: { textAlign: "center" }, },
            { accessorKey: 'monthNmae', header: 'Month Name', size: 100, tableStyle: { textAlign: "center" }, footer: 'Total', },
            { accessorKey: 'totalQty', header: 'total Qty', size: 50, tableStyle: { textAlign: "center" }, footerCellStyle: { textAlign: "center" }, footer: totalGrandQty, },
            {
                accessorKey: "action",
                header: "Action",
                size: 50,
                Cell: ({ row }) => (
                    <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', gap: '1px' }}>
                        <IconButton onClick={() => handleViewClick(row.original.clientCompanyId, row.original.monthDate)}>
                            <VisibilityIcon />
                        </IconButton>
                    </div>
                ),
            },


        ],
        [totalGrandQty]);

    const fetchData = async (clientCompanyId,) => {
        setLoading(true);
        try {
            const payload = {
                customerNamesId: clientCompanyId,
                startDate: "2025-01-01",
                endDate: "2025-12-30"
            };
            const response = await genericPost(GET_CUSTOMER_PRODUCT_MONTHLY, payload);
            const { commercialInvExps } = response.data;

            const monthNames = Object.keys(commercialInvExps);
            let totalQtySum = 0;

            const mappedData = monthNames.map((monthName, index) => {
                const monthData = commercialInvExps[monthName];
                const qty = parseFloat(monthData.totalQty || 0);
                totalQtySum += qty;

                return {
                    index: (index + 1).toString().padStart(2, '0'),
                    monthNmae: monthName,
                    totalQty: qty.toFixed(2),
                    monthDate: monthData.monthDate || "",
                    clientCompanyId: clientCompanyId || "",
                };
            });

            setData(mappedData);
            setGrandQty(parseFloat(totalQtySum.toFixed(2)));
            setClientCompanyName(response.data.clientCompany?.clientCompanyName || "Customer Product Monthly");

        } catch (err) {
            console.error("Fetch Error:", err);
            setError(err.message);
            setData([]);
        } finally {
            setLoading(false);
        }
    };
    useEffect(() => {
        if (!clientCompanyId) return;
        setLoading(true);
        fetchData(clientCompanyId);
    }, [clientCompanyId, token]);

    const handleViewClick = (clientCompanyId, monthDate) => {
        navigate(`/app/reports/customerproductmonthlyinvoice/${clientCompanyId}/${monthDate}`);
    };
    const defaultView = 'customerproduct';
    const mainContent = (
        <>
            <CustomLoader open={loading} />
            <DataTable
                title={clientCompanyName}
                columns={columns}
                data={data}
            />
        </>
    );


    return (
        <>
            <CustomReport
                defaultView={defaultView}
                mainContent={mainContent} />
        </>
    );
};

export default CustomerProductMonthly;
